import React from 'react'
import { isLoggedIn } from './User'
import { Redirect, } from "react-router-dom";

const ROOTPATH = process.env.REACT_APP_ROOT_PATH! || ''
const Auth = (props: any) => {
  return isLoggedIn() ? props.children : <Redirect to={{ pathname: `${ROOTPATH}/login`, state: { from: props.location?.pathname } }} />
}
export default Auth